"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowToolbar = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _toolbarTheme = require("../../../styled/toolbarTheme");
const OverflowToolbar = (0, _styled.default)("div")`
    height: fit-content;
    padding: 8px 8px 0 8px;
    background-color: ${(0, _designTokensReact.color)("color--background--surfaces--work")};

    display: flex;
    align-items: center;
    flex-wrap: wrap;

    max-width: ${_ref => {
  let {
    maxWidth
  } = _ref;
  return maxWidth;
}}px;

    box-shadow: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _toolbarTheme.toolbarOverflowTheme.boxShadow(themeMode);
}};
    border-radius: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _toolbarTheme.toolbarOverflowTheme.borderRadius(themeMode);
}};

    & > div {
        padding-bottom: 8px;
    }
`;
exports.OverflowToolbar = OverflowToolbar;
//# sourceMappingURL=OverflowToolbar.js.map